import {
	Component,
	OnInit,
	Input,
	HostListener,
	QueryList,
	AfterViewInit,
	ChangeDetectorRef,
	Output,
	EventEmitter,
	OnDestroy
} from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { getIdentifierName, getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { SearchTruncated } from 'src/app/_helpers/SearchTruncated'
import { AuthenticationService } from 'src/app/services/authentication.service'
import { HeaderService } from 'src/app/services/header.service'
import { NotificationService } from 'src/app/services/notification.service'
import * as moment_ from 'moment'
import { isValidInt4 } from 'src/app/_helpers/Utils'

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
	@Input() public dtElement: DataTableDirective
	@Input() public updateDataTable: (value) => void
	@Input() public dtElements: QueryList<DataTableDirective>
	@Input() public refreshTable: Subject<any> = new Subject()
	@Input() public hideSearch: boolean = false
	@Input() public valuesSearchTruncated: Array<SearchTruncated> = []
	@Input() public enableSearchTruncated: boolean = false
	@Output() public valueSearchTruncated = new EventEmitter<string>()

	public searchInput = new Subject<string>()
	public handleValuesSearchTruncater: Array<SearchTruncated> = []

	public showSearch: boolean = true
	public openDialog: boolean = false
	public showResultSearch: boolean = false
	public existImage: boolean = false
	public isOpen: boolean = false
	public openSearchTruncated: boolean = false
	public openCancelSearchModal: boolean = false

	public list: any = []
	public imageUser: any
	public dataFilters

	public searchValue: string = ''
	public nameUser: string = ''
	public companyId: string = localStorage.getItem('companyId')
	public companyName: string = localStorage.getItem('companyName')
	public identifierName: string = getIdentifierName()
	public currentRoute: string = ''

	constructor(
		private notificationService: NotificationService,
		private router: Router,
		private cdRef: ChangeDetectorRef,
		private headerService: HeaderService,
		private activatedRoute: ActivatedRoute,
		private authenticationService: AuthenticationService
	) {
		this.searchInput.pipe(
			debounceTime(400),
			distinctUntilChanged()
		).subscribe(value => {
			console.log('search ' + value)
			this._handleSearch()
		})
	}

	@HostListener('click', ['$event'])
	public onClick(event: any): void {
		event.stopPropagation()
		const target: any = event.target
		const { isOpen } = this

		if (target.id !== 'dropdown' && target.id !== 'dropdown-item') {
			this.isOpen = false

			return
		}

		if (target.id === 'dropdown' && isOpen) {
			this.isOpen = false

			return
		}

		this.isOpen = true

		return
	}

	public ngAfterViewInit(): void {
		this.cdRef.detectChanges()
	}

	public async ngOnInit(): Promise<void> {

		this.currentRoute = this.router.url
		this.searchValue =  this.activatedRoute.snapshot.queryParams.search

		if (this.searchValue) {
			setTimeout(() => {
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
					dtInstance.search(this.searchValue, false, true, true)
					dtInstance.draw()
				})
			}, 2000)
		}

		this.isOpen = false
		const userObject: any = getLoggedUser()

		if (userObject.length === 1) {
			this.nameUser = userObject[0].name
			this.imageUser = localStorage.getItem('imageUser')

			if (this.imageUser) {
				this.existImage = true
			}

		} else {
			this.nameUser = userObject.name
			this.imageUser = userObject.media_url
			if (this.imageUser) {
				this.existImage = true
			}
		}
	}

	public redirectForPageBaseadInFilter(): void {
		this.notificationService.initLoading()
	}

	public logout(): void {
		this.authenticationService.logoff()
	}

	public async _handleSearch(): Promise<void> {
		const isNumber = !isNaN(Number(this.searchValue)) && Boolean(this.searchValue)

		if (isNumber) {
			if (!isValidInt4(Number(this.searchValue))) {
				this.notificationService.notify('Valor de busca inválido!', 500)
				return
			}
		}

		this.showResultSearch = this.searchValue && this.currentRoute === '/panel/dashboard'

		if (this.updateDataTable) {
			this.updateDataTable(this.searchValue)
		}

		if (this.dtElement) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				dtInstance.search(this.searchValue, false, true, true)
				dtInstance.draw()
			})
		}

		if (this.currentRoute === '/panel/dashboard') {
			this.dataFilters =
				await this.headerService.filter(this.companyId, this.searchValue).toPromise()
		}

		if (this.dtElements) {
			this.dtElements.forEach(
				(dtElement: DataTableDirective, contador: number) => {
					if (dtElement) {
						dtElement.dtInstance.then(
							(dtInstance: DataTables.Api) => {
								dtInstance.search(
									this.searchValue,
									false,
									true,
									true
								)
								dtInstance.draw()
							}
						)
					}
				}
			)
		}
	}

	public openModal(): void {
		this.openDialog = true
		this.isOpen = false
	}

	public openDetails(): void {
		this.router.navigate(['/panel/userDetail'])
	}

	public close(): void {
		this.openDialog = false
	}

	public emptyValueSearch(): boolean {
		return this.handleValuesSearchTruncater.every(value => value.value === '')
	}

	public openCloseSearchTruncated(open: boolean) {

		if (!open) {
			const noChanges: boolean =
				this.equalityTest(this.valuesSearchTruncated, this.handleValuesSearchTruncater)

			if (!noChanges) {
				this.openCloseCancelModal()
				return
			}
		}

		this.handleValuesSearchTruncater = this.deepCopy(this.valuesSearchTruncated)
		this.openSearchTruncated = open
	}

	public closeSearchTruncated() {
		this.openCancelSearchModal = false
		this.openSearchTruncated = false
	}

	public openCloseCancelModal() {
		this.openCancelSearchModal = !this.openCancelSearchModal
	}

	public createStringSearchTruncate(): string {
		let stringSearchFormated: string = ''

		this.handleValuesSearchTruncater.forEach(value => {
			if (value.value) {

				let valueToSearch: string = ''

				// Se o atributo dor do tipo data, acrescenta um dia para que a API possa realizar a busca corretamente
				if (value.type == 'date') {

					valueToSearch = moment_(`${value.value} 12:00:00`).format('YYYY-MM-DD')

				} else {

					valueToSearch = value.value

					// Se o atributo for categoryRisk, formata  valor muito alto acrescentando o "_"
					if (value.key == 'categoryRisk') {
						valueToSearch =
							valueToSearch.toLowerCase() == 'muito alto' ? 'muito_alto' : valueToSearch
					}
				}

				stringSearchFormated += `&${value.key}=${valueToSearch}`
			}
		})

		if (stringSearchFormated) {
			stringSearchFormated += '&truncate=true'
		}

		return stringSearchFormated
	}

	public searchTruncated() {
		const stringSearchTruncatedFormated = this.createStringSearchTruncate()

		this.valueSearchTruncated.emit(stringSearchTruncatedFormated)
		this.valuesSearchTruncated = this.deepCopy(this.handleValuesSearchTruncater)

		this.openSearchTruncated = false
	}

	public clearItem(index: number) {
		if (this.handleValuesSearchTruncater[index].value != '') {
			this.handleValuesSearchTruncater[index].value = ''
		}
	}

	public clearAllItens() {
		this.handleValuesSearchTruncater.forEach(item => {
			item.value = ''
		})

		const handleEqualsGlobalValues: boolean =
			this.equalityTest(this.valuesSearchTruncated, this.handleValuesSearchTruncater)

		if (handleEqualsGlobalValues) {
			return
		}

		this.valueSearchTruncated.emit('')
		this.valuesSearchTruncated = this.deepCopy(this.handleValuesSearchTruncater)
	}

	public deepCopy(obj: Array<SearchTruncated>): Array<SearchTruncated> {
		return JSON.parse(JSON.stringify(obj))
	}

	public equalityTest(obj1: Array<SearchTruncated>, obj2: Array<SearchTruncated>): boolean {
		return JSON.stringify(obj1) === JSON.stringify(obj2)
	}

	public ngOnDestroy(): void {
		this.valuesSearchTruncated.forEach(value => {
			value.value = ''
		})
	}
}
